import {
  profileVisibility,
  shareableProfileSettings,
  approachability,
} from './profileVisibility-mock';

export const visibilityMockOverrides = {
  ProfileVisibility: () => profileVisibility,
  Approachability: () => approachability,
  ShareableProfileSettings: () => shareableProfileSettings,
};
